export default __webpack_public_path__ + "static/media/hfty.600dbb50.png";